import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import partialRight from 'lodash/partialRight';
import { isError as isErrorSelector, getErrorMsg } from '../redux/selectors';
import { resetEditorPublishResults } from '../redux/actionCreators';
/** Displays a `window.alert` if the comment editor has an error. */
export function useCommentEditorError(commentBoxId) {
    var dispatch = useDispatch();
    var isError = useSelector(partialRight(isErrorSelector, commentBoxId));
    var errorMessage = useSelector(partialRight(getErrorMsg, commentBoxId));
    // TODO: get designers to make nice errors
    useEffect(function () {
        if (isError && typeof window !== 'undefined') {
            window.alert(errorMessage);
            dispatch(resetEditorPublishResults(commentBoxId));
        }
    }, [isError, errorMessage, dispatch, commentBoxId]);
}
//# sourceMappingURL=useCommentEditorError.js.map